import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/clients.php`;

export const deleteClient = (id) => axios.delete(`${API_URL}?id=${id}`);
